import React from 'react'
import Select from '../Atoms/Select/Select'
import { SelectOption } from '../Atoms/Select/Select.types'

type Props = {
    onChange: (value: string) => void
    value?: string
}

const options: SelectOption[] = [
    { value: 'ascending', label: 'Ascending' },
    { value: 'descending', label: 'Descending' },
]

const PivotTableSortDirectionEditor: React.FC<Props> = ({ onChange, value }) => {
    return (
        <Select
            options={options}
            value={value ?? 'ascending'}
            onChange={onChange}
            isClearable={false}
            isSearchable={false}
        />
    )
}

export default PivotTableSortDirectionEditor
